import styled from 'styled-components';
export const DialogContentWrapper = styled.div`
  flex: 1 1 auto;
  padding: 8px 24px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  ${props => props.dividers ? `
padding: 16px 24px;
border-top: 1px solid rgba(0, 0, 0, 0.12);
border-bottom: 1px solid rgba(0, 0, 0, 0.12);` : ''}
`;